<template>
  <div class="form-group">
    <label class="form-label">Событие</label>
    <span class="subtitle">Расторжение трудового договора по причине (отметить из списка):</span>

    <div class="checkbox-group">
      <div v-for="option in options.jobLoss" :key="option.name" @click.prevent="setSelected(option.name)" class="label-checkbox-pair">      
        <input type="checkbox" :id="option.name" :checked="selected==option.name">
        <label :for="option.name">{{ option.text }}</label>
      </div>
    </div> 
  </div>

  <div class="form-group">
    <span class="subtitle">Снижение заработной платы по причине (отметить из списка):</span>
    <div class="checkbox-group">
      <div v-for="option in options.salaryDecrease" :key="option.name" @click.prevent="setSelected(option.name)" class="label-checkbox-pair">      
        <input type="checkbox" :id="option.name" :checked="selected==option.name">
        <label :for="option.name">{{ option.text }}</label>
      </div>
    </div> 
  </div>

  <div class="form-group">
    <label class="form-label">Что именно произошло (дополнительные комментарии к событию)</label>
    <textarea name="comments" class="form-textarea" rows="6" v-model="comments"></textarea>
  </div>

  <ContractInfoApplicant/>
</template>

<script>
import ContractInfoApplicant from "@/components/insurances/shared/ContractInfoApplicant";
import * as mns from "@/store/mutation-types";

export default {
  anotherNameLife: "JobLossOrSalaryDecreaseInsurance",
  components: {ContractInfoApplicant},
  data: ()=>({
    options: {
      jobLoss: [
        {
          name: 'jobLossInputDownsizing',
          text: 'Сокращение численности штата'   
        },
        {
          name: 'jobLossInputOrganizationLiquidation',
          text: 'Ликвидация организации'   
        },
        {
          name: 'jobLossInputOwnershipChange',
          text: 'Смена собственника имущества организации'   
        },
        {
          name: 'jobLossInputEmployeeRecovery',
          text: 'Восстановление работника, ранее выполнявшего работу'   
        },
        {
          name: 'jobLossInputRefusalToTransfer',
          text: 'Отказ работника от перевода на работу в другую местность'   
        },
        {
          name: 'jobLossInputByAgreement',
          text: 'По соглашению сторон'   
        },
        {
          name: 'jobLossInputOther',
          text: 'Другое'   
        }
      ],
      salaryDecrease: [
        {
          name: 'idleTime',
          text: 'Введения простоя работодателем'
        },
        {
          name: 'forcedReduction',
          text: 'Принудительного сокращения рабочего времени'
        }
      ]
    },
    selected: ''
  }),
  methods: {
    setSelected(value){
      this.selected = value
      this.$store.commit(mns.SET_EVENT, this.selected);
    },
  },
  computed: {
    comments: {
      get(){
        return this.$store.getters.comments;
      },
      set(value){
        this.$store.commit(mns.SET_COMMENTS, value);
      }
    }
  }
}
</script>

<style scoped>
  .subtitle{
    display: block;
    font-size: .8rem;
    color: #9e9e9e;
  }
</style>